import { Box, Paragraph } from '@zillow/constellation-10';
import { useLeasingUrlParams } from '../../../../hooks/useLeasingUrlParams';

import { MAXIMUM_NUMBER_OF_DOCUMENTS } from '../../../../pages/LandlordLeaseView/SelfServeView/UploadedLease';
import LeaseUploader from '../../../LeaseUploader';
import DocumentCard from './DocumentCard';
import type { DocumentDetailsDto } from '@zg-rentals/ts-leasing-client';
import { useUploadedFileDetailsQuery } from '../../../../utils/queries';

function DocumentListAndUploader() {
  const { leaseId } = useLeasingUrlParams();
  const { data: uploadedFileDetails = [] } = useUploadedFileDetailsQuery(Number(leaseId));

  function renderAddMoreDocuments() {
    return uploadedFileDetails.length === MAXIMUM_NUMBER_OF_DOCUMENTS ? (
      <Box css={{ marginTop: 'layout.tight' }}>
        <Paragraph>{`You’ve added ${MAXIMUM_NUMBER_OF_DOCUMENTS} documents, which is the maximum allowed.`}</Paragraph>
      </Box>
    ) : (
      <Box css={{ marginTop: 'layout.tight' }}>
        <LeaseUploader />
      </Box>
    );
  }

  return (
    <>
      {uploadedFileDetails.map((leaseDetail: DocumentDetailsDto) => (
        <Box key={leaseDetail.id} css={{ marginBottom: 'layout.tight' }}>
          <DocumentCard leaseDetail={leaseDetail} />
        </Box>
      ))}
      {renderAddMoreDocuments()}
    </>
  );
}

export default DocumentListAndUploader;
